import MasterReportComponent from "~/components/pages/supervisor/master";

export default function ReportsPage() {
  return (
    <div>
      <MasterReportComponent />
    </div>
  );
}
